import { render, staticRenderFns } from "./crosspermissions.vue?vue&type=template&id=851306be&scoped=true"
import script from "./crosspermissions.vue?vue&type=script&lang=js"
export * from "./crosspermissions.vue?vue&type=script&lang=js"
import style0 from "./crosspermissions.vue?vue&type=style&index=0&id=851306be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851306be",
  null
  
)

export default component.exports